import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import CustomReveal from './CustomReveal';
import { SmartButton } from '../../common/SmartButton';
import CustomIcon from '../CustomIcon';
import { I18n } from 'react-redux-i18n-lite';
import * as revealActions from '../../../actions/revealActions';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import { bindActionCreators } from 'redux';
import UserList from '../../classroom/students/AddUsers/UserList';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class StudentsWithFilesReveal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.any,
    assignmentsDrawerActions: PropTypes.any,
    students: PropTypes.array
  };

  closeModal = () => {
    this.props.revealActions.openStudentsWithFilesReveal(false);
  };

  submit = () => {
    this.props.revealActions.studentsWithFilesConfirmation(true);
    this.props.revealActions.openStudentsWithFilesReveal(false);
  };

  render() {
    const { students } = this.props;

    return (
      <Modal
        id="remove-book"
        title={I18n.t('studentsWithFilesReveal.title')}
        active
        onClickOutside={this.closeModal}
        children={
          <>
            <Paragraph className="text-grey-700">{I18n.t('studentsWithFilesReveal.contentTop')}:</Paragraph>
            <div className="margin-top-20 margin-bottom-20">
              <UserList users={students} />
            </div>
            <Paragraph className="text-grey-700">{I18n.t('studentsWithFilesReveal.contentBottom')}</Paragraph>
          </>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.submit} primary label={I18n.t('common.option.remove')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    students: state.reveal.students
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentsWithFilesReveal);
